import {
  createContext,
  type FunctionComponent,
  type ReactNode,
  useContext,
} from 'react';
import { Container, type ContainerInstance } from 'typedi';

const ContainerContext = createContext<ContainerInstance>(Container.of());

export type ContainerProviderProps = {
  children?: ReactNode;
  container: ContainerInstance;
};

export const ContainerProvider: FunctionComponent<ContainerProviderProps> = ({
  children,
  container,
}) => {
  return (
    <ContainerContext.Provider value={container}>
      {children}
    </ContainerContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- Not refreshed frequently
export const useContainer = (): ContainerInstance => {
  return useContext(ContainerContext);
};
